<main>
  <div class="max-w-[1000px] mx-auto min-h-[100vh]">
    <router-outlet />
  </div>
</main>
